import { Dialog, DialogBody, DialogTitle, EditProps } from '@/components/base/dialog'
import { Form as EditForm } from './edit_form'
import { EditEventStageQuery } from './__generated__/edit_query'
import { Query } from './edit_query'
import { useQuery } from '@apollo/client'
import { Inline as Loading } from '@/components/loading'

interface Props extends EditProps {
  eventId: string
}

export const EditDialog = ({ eventId, id, open, setOpen }: Props) => {
  const { data, loading } = useQuery<EditEventStageQuery>(Query, { variables: { eventId, eventStageId: id } })

  return (
    <>
      <Dialog open={open} size="3xl" onClose={setOpen}>
        <DialogTitle>
          <div>
            { loading || !data ? <Loading /> : data.events.nodes[0].eventStages.nodes[0].name }
          </div>
        </DialogTitle>
        <DialogBody>
          <EditForm eventId={eventId} id={id} onSuccess={() => setOpen(false)} />
        </DialogBody>
      </Dialog>
    </>
  )
}
